module.exports = __webpack_public_path__ + "img/TrustBy_GoodX.e16de81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/professional/TrustBy_GoodX.png
// module id = 604
// module chunks = 5